import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "app" }

import BasicLayout from "@/layouts/BasicLayout.vue";
import { useRoute } from "vue-router";
import { computed, onMounted } from "vue";
import { useDarkModeStore } from "@/store/themeStore"; //  store 管理主题状态
import type ArcoVue from "@arco-design/web-vue";
type Theme = ArcoVue.Theme;


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const themeStore = useDarkModeStore();
const theme = computed<Theme>(() => {
  return themeStore.isDark ? "dark" : "light";
});

const route = useRoute();
/**
 * 全局初始化函数，有全局单次调用的代码，都可以写到这里
 */
const doInit = () => {
  console.log("hello 欢迎来到我的项目");
};
onMounted(() => {
  doInit();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, { theme: theme.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(route).path.startsWith('/user'))
          ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
          : (_openBlock(), _createBlock(BasicLayout, { key: 1 }))
      ])
    ]),
    _: 1
  }, 8, ["theme"]))
}
}

})